import Route from '@ember/routing/route';

import { set } from '@ember/object';

export default class IndexRoute extends Route {
  setupController(/*controller*/) {
    var application = this.controllerFor('application');
    set(application, 'showCart', null);
    set(application, 'showMenu', null);
    //application.loadDataTask.perform();
  }
}
